(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promo-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById("velora-promo");
    if (!root) return;

    var SESSION = "velora_promo_closed";
    var copyBtn = root.querySelector("[data-promo-copy]");
    var lastFocus = null;

    try {
      localStorage.removeItem("velora_promo_glow30");
    } catch (err) {}

    function used() {
      return root.getAttribute("data-used") === "1";
    }

    function closedThisTab() {
      try {
        return sessionStorage.getItem(SESSION) === "1";
      } catch (err) {
        return false;
      }
    }

    function dismiss() {
      try {
        sessionStorage.setItem(SESSION, "1");
      } catch (err) {}
      root.setAttribute("hidden", "");
      document.body.style.removeProperty("overflow");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function cookieBannerOpen() {
      var banner = document.getElementById("shopify-pc__banner");
      if (!banner) return false;
      var style = window.getComputedStyle(banner);
      return style.display !== "none" && style.visibility !== "hidden" && banner.getClientRects().length > 0;
    }

    function cartOrHere() {
      var path = location.pathname || "/";
      var dest = path.replace(/^\/us(?=\/|$)/i, "") || "/";
      return dest + (location.search || "");
    }

    function applyCode(redirectPath) {
      var code = root.getAttribute("data-code") || "GLOW30";
      try {
        sessionStorage.setItem("velora_glow30_on", "1");
        sessionStorage.setItem(SESSION, "1");
      } catch (err) {}
      var dest = redirectPath || cartOrHere();
      location.assign("/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(dest));
    }

    function open() {
      if (used() || closedThisTab()) return;
      lastFocus = document.activeElement;
      root.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
      if (copyBtn) copyBtn.focus();
    }

    function waitThenOpen() {
      if (used() || closedThisTab()) return;
      var started = Date.now();
      var timer = setInterval(function () {
        if (Date.now() - started < 800) return;
        if (cookieBannerOpen() && Date.now() - started < 4000) return;
        clearInterval(timer);
        open();
      }, 200);
    }

    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-promo-dismiss]")) {
        event.preventDefault();
        dismiss();
      }
    });

    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var code = root.getAttribute("data-code") || "GLOW30";
        var done = root.getAttribute("data-copied") || "Copied";
        var original = root.getAttribute("data-copy-label") || copyBtn.textContent;
        function mark() {
          copyBtn.textContent = done;
          setTimeout(function () {
            copyBtn.textContent = original;
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(mark).catch(mark);
        } else {
          mark();
        }
        applyCode();
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !root.hasAttribute("hidden")) {
        event.preventDefault();
        dismiss();
      }
    });

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", waitThenOpen);
    else waitThenOpen();
  })();
  } catch(e) { console.error(e); }
})();

})();
